module.exports = __webpack_public_path__ + "static/media/big_check.3bc73f40.svg";